export const SET_PRACTICE_ID = "SET_PRACTICE_ID";
export const SET_USER_PROFILE = "SET_USER_PROFILE";
export const SET_ACCOUNT_ID = "SET_ACCOUNT_ID";
export const SET_USERNAME = "SET_USERNAME";
export const SET_PASSWORD = "SET_PASSWORD";
export const SET_OTPMETHOD = "SET_OTPMETHOD";
